import { CoordGeodetic } from '../../service/coord-helper.service';
import { FdmPlugin, FdmPluginInterface } from './plugins';

const Cesium = (<any>window).Cesium;

export class Images360Controller extends FdmPlugin implements FdmPluginInterface {

    // required name identifier
    static meta = {
        label: 'PLUGINS.IMAGES_360_CONTROLLER.LABEL',
        name: 'images-360-controller',
        translator: 'PLUGINS.IMAGES_360_CONTROLLER',
        tooltip: 'PLUGINS.IMAGES_360_CONTROLLER.TOOLTIP',

        hideHeader: true,

        category: FdmPlugin.category.generic,
        cardinality: FdmPlugin.cardinality.one,
        types: [ FdmPlugin.types.imageController ]
    };

    controls:any = {
        exit:      { type:'button', icon:'times-circle', action:'exiting', class:'fdm-button-fancy float-right', nolabel:true, noshow:true },
        loading:   { type:'loading', noshow:true },
        alpha:     { type:'slider', value:0.95, min:0, max:1, step:0.01, nolabel:true, noshow:true, class:'in-widget-ui' }
    }

    // don't show a header
    // hideHeader:boolean = true;


    meId:any = null;

    insideSphere:boolean = false;

    coord:any = null;

    sphere:any = null;

    originalCamera:any = null;

    rotation = Cesium.Math.toRadians(90);

    // a panel is a UI widget for a generic UI
    panel:any = null;

    // our image (DOB object)
    image:any = null;

    // our DOM canvas for image manipulation
    canvas:any = null;

    // sidenav item (for opening and closing)
    sidenavSwitch:any = null;
    sidenavOriginalState:boolean = false;

    photobucket:any = null;
    photobucketOriginalState:boolean = false;


    coordHelper:any = null;
    mapService:any = null;
    sceneController:any = null;
    uiManager:any = null;

    getRotationValue() {
        this.rotation += 0.05;
        return this.rotation;
    }

    itemInjected() {

        this.coordHelper = this.services.coordHelper;
        this.mapService = this.services.mapService;
        this.sceneController = this.services.sceneController;
        this.uiManager = this.services.uiManager;

        this.coord = { lat: this.item.ulat, long: this.item.ulng, height: this.item.uheight };
        let o = new CoordGeodetic(this.coord);

        let pos = this.coordHelper.toCartesian ( o );

        this.entity ( 'enter', this.mapService.viewer.entities.add ({
            name: 'enter image 360',
            type: 'pluginref',
            plugin_id: this.id,
            position: pos,
            show:true,
            billboard : {
                image : 'assets/images/icons/image-360.png',
                verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                scaleByDistance: new Cesium.NearFarScalar(0, 2, 1500, 0.8)
            }
        }));

    }

    flying() {
        this.flyTo('enter');
    }

    loadingSphere ( coord:CoordGeodetic = null, image:any = null ) {

        let size = 30;

        let cart2 = Cesium.Cartesian3.fromDegrees( coord.long, coord.lat );

        var ellipsoidGeometry = new Cesium.EllipsoidGeometry({
            radii : new Cesium.Cartesian3(size, size, size),
            id: 'loadingsphere'
        });

        var apr = new Cesium.MaterialAppearance({
            material: new Cesium.Material({
                fabric: {
                    
                    uniforms : {
                        image : image,
                        repeat : new Cesium.Cartesian2(1.0, 1.0),
                        alpha : this.controls.alpha.value
                    },
                    components : {
                        diffuse : 'texture2D(image, fract(repeat * materialInput.st)).rgb',
                        alpha : 'texture2D(image, fract(repeat * materialInput.st)).a * alpha'
                    }

                }
            }),
            translucent : true,
            faceForward: true,           
        });

        var imgEllipsoidInstance = new Cesium.GeometryInstance({
            geometry : ellipsoidGeometry,
            modelMatrix : Cesium.Matrix4.multiplyByTranslation(
                Cesium.Transforms.eastNorthUpToFixedFrame(cart2), //this is lat long
                new Cesium.Cartesian3(0.0, 0.0, this.coord.height ), //this is height
                new Cesium.Matrix4()
            )
        });

        const p = this.mapService.viewer.scene.primitives.add(new Cesium.Primitive({
            geometryInstances: imgEllipsoidInstance,
            appearance: apr
        }));
            
        // console.log('@@ NEW PRIMITIVE',p);
        return p;

    }

    flipImage ( image:any ) {

        return new Promise(resolve => {

            let canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            let ctx = canvas.getContext('2d');
            
            ctx.scale(-1, 1);
            ctx.drawImage(image, -image.width, 0);
            ctx.setTransform(1, 0, 0, 1, 0, 0);

            resolve(canvas);
        });

    }

    loadImage(url) {
        return new Promise(resolve => {
            const image = new Image();
            image.addEventListener('load', () => {
                resolve(image);
            });
            // start loading the image
            image.src = url;
        });
    }

    // incoming click event on the exit button, just call this.enter() again (as a toggle)
    exiting() {
        // console.log('@@ exiting()',this.meId);
        this.enter ( this.meId );
    }

    enter( id:any = null ) {

        // console.log('@@ enter()');

        // trying to enter an entered sphere? Then exit!
        if ( id == this.meId && this.insideSphere ) {
            
            this.crawlOutOfImage();
            return;
        }

        // save the camera position
        this.originalCamera = this.sceneController.getCamera();

        // add a UI panel with this plugin's controls
        this.panel = this.uiManager.createPanel(this);
        this.panel.show = true;

        // console.log('## 360_panel',this.panel);

        // this.uiManager.addPanel ( 'i360-'+this.item.id, null, this );

        // already create a sphere?
        if ( ! this.sphere ) {

            // console.log('@@ enter() NO SPHERE');

            // no, so start with getting the Item's dataset (input) file
            let ds = this.item.input;

            // show loading spinner
            this.controls.loading.noshow = false;

            Cesium.Resource.fetchImage({ url: ds.file(ds.name), headers: { 'Access-Control-Allow-Origin': '*' } }).then( image => {

                // image.crossOrigin = "Anonymous";

                this.flipImage(image).then( canvas => {

                    // console.log ( '*** IMG', ds.name, ds.file(ds.name), image, canvas);

                    // console.log('@@ enter() SPHERE LOADED');

                    this.sphere = this.loadingSphere ( this.coord, canvas );

                    // image is no longer needed as we have a canvas copy
                    image.remove();

                    this.meId = id;

                    // give it some time to capture camera position before setting it elsewhere
                    setTimeout ( () => {
                        this.crawlInsideImage();
                    }, 100 );

                });

            });

        } else {

            // console.log('@@ enter() SPHERE');

            // yes, then crawl inside
            this.crawlInsideImage();
        }
        
    }

    crawlInsideImage() {

        // console.log('@@ crawInsideImage()');

        // are we inside?
        this.insideSphere = true;

        // hide 'enter' icon
        this.entity('enter').show = false;

        // hide loading spinner
        this.controls.loading.noshow = true;
        
        // show the exit button
        this.controls.exit.noshow = false;

        // show the opacity slider
        this.controls.alpha.noshow = false;

        // turn the sphere on (if it isn't already)
        this.sphere.show = true;

        this.uiManager.hideAll ( 'i360-'+this.item.id );

        this.enterFullscreen();

        let cart3 = Cesium.Cartesian3.fromDegrees( this.coord.long, this.coord.lat, this.coord.height );
        this.mapService.viewer.camera.lookAt(cart3, new Cesium.HeadingPitchRange(0, 0, 10));
    }

    crawlOutOfImage() {

        // console.log('@@ crawOutOfImage()');

        // are we inside?
        this.insideSphere = false;

        // show 'enter' icon
        this.entity('enter').show = true;

        // hide the photo sphere
        this.sphere.show = false;

        // hide the exit button
        this.controls.exit.noshow = true;

        // hide the opacity slider
        this.controls.alpha.noshow = true;

        this.exitFullscreen();

        // remove the UI panel (only removed in exit)
        // this.uiManager.removePanel ( 'i360-'+this.item.id );

        this.panel = this.uiManager.deletePanel(this.panel);

        this.uiManager.showAll();


        // reset the camera viewer
        this.mapService.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
        this.sceneController.setCamera( this.originalCamera );
    }

    enterFullscreen() {

        // console.log('@@ enterFullscreen()');

        this.sidenavOriginalState = false;
        this.photobucketOriginalState = false;

        this.sidenavSwitch = document.getElementById('fdm-sidebar-switch');
        this.photobucket = document.getElementById('fdm-photo-bucket');

        if ( this.sidenavSwitch ) {
            if ( this.sidenavSwitch.classList.contains('fdm-sidebar-switch-right') ) {
                this.sidenavOriginalState = true;
                this.sidenavSwitch.click();
            } else {
                this.sidenavOriginalState = false;
            }
        }
        if ( this.photobucket ) {
            if ( this.photobucket.classList.contains('show-bucket') ) {
                this.photobucketOriginalState = true;
                this.photobucket.classList.add('noshow');
            }
        }
    }

    exitFullscreen() {
        // console.log('@@ exitFullscreen()');
        if ( this.sidenavSwitch && this.sidenavOriginalState ) { 
            this.sidenavSwitch.click();
        }
        if ( this.photobucket ) {
            if ( this.photobucket.classList.contains('show-bucket') ) {
                this.photobucket.classList.remove('noshow');
            }
        }
        this.sidenavOriginalState = false;
        this.photobucketOriginalState = false;
    }

    refresh( newvalue = null, section:any = null ) {

        // check in with mama
        super.refresh ( newvalue, section );

        if ( this.sphere ) {
            this.sphere.appearance.material.uniforms.alpha = this.controls.alpha.value;
        }
    }

    // when plugins end ...
    end() {
        this.wipe();
        this.mapService.viewer.scene.primitives.remove ( this.sphere );
    }


    
}


